import { NakedButton } from '@cb/apricot-react';
import CheckIcon from '@mui/icons-material/Check';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { styled } from '@mui/system';

import { INote, ISummary } from 'src/types';

const ActionList = styled('div')`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
`;

const ActionButton = styled(NakedButton)`
  padding: 0;
`;

interface VettingNotesProps {
  request: ISummary;
  onClickAddVettingNotes: (request: ISummary) => void;
  onClickViewVettingNotes: (request: ISummary) => void;
}

interface NoteProps {
  note: INote;
}

export const Note = ({ note }: NoteProps) => {
  return <div style={{ padding: '5px 0px 0px 5px', lineHeight: '1.4em' }}>
    <div style={{ fontWeight: 500, maxWidth: '400px', backgroundColor: '#f6f6f6', borderRadius: '5px', padding: '5px 5px', whiteSpace: 'pre-line' }}>{note.message}</div>
    <div style={{ fontSize: 11, color: '#7b7b7b' }}>
      <span style={{ fontStyle: 'italic' }}>{note.user || ''}</span>&nbsp;@&nbsp;{new Date(note.time).toLocaleString()}
    </div>
  </div>;
};


export const VettingNotes = ({ request, onClickAddVettingNotes, onClickViewVettingNotes }: VettingNotesProps) => {
  if (!request.processStatus) {
    return null;
  }

  const notes = (request.adminNotes?.slice() || []);
  const totalNotes = notes.length;
  const latestNote = notes.pop();

  const handleClickAddVettingNotes = () => {
    onClickAddVettingNotes(request);
  };

  const handleClickViewVettingNotes = () => {
    onClickViewVettingNotes(request);
  };


  switch (request.processStatus) {
    case 'submitted':
      return null;
    case 'processing':
    case 'reopen':
    case 'rejected':
    case 'appeal':
    case 'international':
    case 'testSecurity':
    case 'opsApproved':
      return (
        <ActionList>
          {latestNote &&
            <Note note={latestNote} />
          }
          <ActionButton onClick={handleClickAddVettingNotes}>
            <BorderColorIcon />
            Enter Notes
          </ActionButton>
          <ActionButton onClick={handleClickViewVettingNotes} style={{ marginBottom: '10px' }}>
            <CheckIcon />
            Review Notes ({totalNotes})
          </ActionButton>

        </ActionList >
      );
    case 'completed':
      return (
        <ActionList>
          {latestNote &&
            <Note note={latestNote} />
          }
          <ActionButton onClick={handleClickViewVettingNotes} style={{ marginBottom: '10px' }}>
            <CheckIcon />
            Review Notes ({totalNotes})
          </ActionButton>
        </ActionList>
      );
    default:
      return null;
  }
};

